module.exports = __webpack_public_path__ + "img/HA1506-169.d59da8a9.jpg";